import { createRouter, createWebHistory } from "vue-router";
import HomePage from './components/HomePage';
import DashBoard from './components/DashBoard';

const routes = [ 
    {'path' : '/', component : HomePage},
    { 'path' : '/dashboard', component : DashBoard}
]

const router = createRouter({
    history: createWebHistory('/'), routes
})


export default router
